export const scrollLinkClass =
  "cursor-pointer text-muted-foreground hover:text-premium-600 font-medium transition-colors";

export const mobileScrollLinkClass =
  "cursor-pointer block w-full text-left px-3 py-2 text-base font-medium text-foreground hover:text-premium-600 hover:bg-muted/50 rounded-md";
